export const FAQFirst = [
  {
    question: "How do I buy Holy Sharks?",
    answer:
      "<div>We open a limited sale on the mint site. Users who are unable to participate in this presale can purchase them on the marketplace.</div>",
  },
  {
    question: "What can I do with my Holy Sharks?",
    answer:
      "<div>NFT Holy Shark is not only a collectible but also a game character. Each Holy Shark has unique skills and abilities to help you on your journey. People can go on a quest to collect Sharks, fight world bosses, assemble their team to participate in tournaments, trade Sharks with others, and especially participate in the ocean economy, in which market activities, auctions, and entertainment will take place in the Holy World.</div>",
  },
  {
    question: "What are the rarities of Sharktopia?",
    answer:
      "<div>Normal, Uncommon, Rare, Epic, Legendary, Mythic, Unique, Demi-God và God.</div>",
  },
  {
    question: "Can I search for a specific Holy Sharks?",
    answer:
      "<div>Of course. You can search by Holy Sharks id number on the marketplace. We have many filters so that users can find the Holy Sharks they want as quickly as possible.</div>",
  },
  {
    question: "Will my NFT be able to level up or change it's attributes?",
    answer:
      "<div>Correctly. By participating in in-game activities such as PVE, PVP - the character's attributes will be upgraded. Then, users will have the opportunity to participate in more strenuous exercises to receive higher rewards. You are still free to sell and trade your original Sharktopia on the marketplace. However, any additional bonus that you collect (cool new weapons or cosmetic costumes) can be sold and traded on the marketplace.</div>",
  },
  {
    question:
      "How important are Holyshark’s base level/stats and what is the max of each in game?",
    answer:
      "<div>The stats you see on Sharktopia NFT are base stats and can be considered as pure stats your Sharktopia has BEFORE any gear is equipped. Most equipment adds stats to your base stats.</div>",
  },
  {
    question: "How many different attributes are there for each Sharktopia?",
    answer:
      "<div>There are 14 different attributes and they are Place of Birth, Weapon, Wings, Body, Tail, Fin accessories, Shoe, Suit, Bracelet, Necklace, Mouth, Eyes, Hat, Glasses.</div>",
  },
  {
    question: "Will there be a HLS ( Sharktopia Token) public sale?",
    answer: "<div>Estimated time is in Q1/2022.</div>",
  },
];

export const FAQSecond = [
  {
    question: "What are Sharktopia Game?",
    answer:
      "<div>Sharktopia Game is a flexible combination of players and shark skills.<br/>Players must use these combinations to create a variety of tactics as well as competitive lineups. That will create a harsh competitive environment where players can use their brains to earn GDC and HLS.</div>",
  },
  {
    question: "When are Sharktopia Game available to play?",
    answer: "<div>Sharktopia Game will launch in Q1-2022 (estimated)</div>",
  },
  {
    question: "What platforms will Sharktopia Game be released on?",
    answer:
      "<div>We'll prioritize the PC release first. After that, it will develop on Android and IOS later.</div>",
  },
  {
    question: "How many Sharktopia will I need to play the game?",
    answer:
      "<div>We have two game modes, 3v3 and 5v5. So players need at least 3 NFTs to play the game.</div>",
  },
  {
    question: "What are the main features of the game?",
    answer:
      "<div>When playing this game, players will transform into 3D characters to integrate into a whole new world, including farming, breeding, fishing, etc. Players can craft accessories such as clothes, shoes, and hats. And can also conduct transactions with each other. Besides, players and shark also have to fight with the monster to protect the territory and receive rewards to upgrade the attribute indicators.</div>",
  },
  {
    question: "Are there any plans for multiplayer? Either cooperative or PVP?",
    answer:
      "<div>We designed and are testing in PVP mode. In this mode, with the flexibility of tactics as mentioned above, players must show their ingenious layout with the sharks to win and worthy rewards for themselves. And of course, we will also have a leaderboard and distribute dividends on the last day of each month.</div>",
  },
  {
    question:
      "Will there be different difficulty levels and/or challenge modes in the game?",
    answer:
      "<div>In addition to developing PvP, we are also developing and testing a PvE area, where players can choose monsters with different ranks according to the player's strength to challenge and get EXP and rewards.<br/>After leveling up, players will receive upgrade points that can be used to upgrade the stats of sharks such as HP, DF, etc. This leads to the growth of sharks in terms of strength and can fight stronger monsters or fight higher-ranked players for more rewards.</div>",
  },
];
